import { useQuery } from 'react-query';
import { APIErrorType } from '../../api';
import { UseQueryOptions, UseQueryResult } from 'react-query/types/react/types';
import { ExamType, fetchAvailableExams, fetchExam } from '../../api/exam';

export type useExamsReturnType = UseQueryResult<ExamType[]>;

export function useExams(): useExamsReturnType {
  return useQuery<ExamType[], APIErrorType>('exams', fetchAvailableExams, {
    staleTime: 30 * 1000,
    retry: false
  });
}

export type useExamReturnType = UseQueryResult<ExamType>;

export function useExam(
  examId: number | undefined,
  options: Omit<
    UseQueryOptions<ExamType, APIErrorType, ExamType, [string, number]>,
    'queryKey | queryFn'
  > = {}
): useExamReturnType {
  if (!examId) throw Error('examId is undefiend');
  return useQuery<ExamType, APIErrorType, ExamType, [string, number]>(
    ['exams', examId],
    fetchExam,
    {
      staleTime: 30 * 1000,
      retry: false,
      ...options
    }
  );
}
